import { FC } from "react";
import { useTranslation } from "react-i18next";

import { IDropdownItem, noop } from "@ryde/shared";

import {
  DropdownTemplate,
  TemplateWrapper,
  TextboxTemplate,
} from "../../../dynamic-forms";
import { BookingApproveFormFieldsEnum } from "./form-constants";

interface IApprovalErrorFieldsProps {
  reasonCategoryDropdownItems?: IDropdownItem[];
  reasonDropdownItems?: IDropdownItem[];
}

export const ApprovalErrorFields: FC<IApprovalErrorFieldsProps> = ({
  reasonCategoryDropdownItems,
  reasonDropdownItems,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <TemplateWrapper>
        <DropdownTemplate
          formLabel={t("booking.APPROVAL_REASON_CATEGORY")}
          name={BookingApproveFormFieldsEnum.APPROVAL_REASON_CATEGORY}
          formAttributes={{
            selectItems: reasonCategoryDropdownItems ?? [],
          }}
        />
      </TemplateWrapper>
      <TemplateWrapper>
        <DropdownTemplate
          formLabel={t("booking.APPROVAL_REASON")}
          name={BookingApproveFormFieldsEnum.APPROVAL_REASON_ID}
          formAttributes={{
            selectItems: reasonDropdownItems,
          }}
          formValidation={{
            type: "number",
            rules: [
              {
                validation: "required",
              },
            ],
          }}
          onBlur={noop}
        />
      </TemplateWrapper>
      <TemplateWrapper>
        <TextboxTemplate
          name={BookingApproveFormFieldsEnum.APPROVER}
          formLabel={t("booking.APPROVER")}
          formValidation={{
            type: "string",
            rules: [
              {
                validation: "required",
              },
              {
                validation: "min",
                params: [1],
              },
            ],
          }}
          onBlur={noop}
        />
      </TemplateWrapper>
    </>
  );
};
